/*
 * AnswerImageUpload Messages
 *
 * This contains all the text for the AnswerImageUpload component.
 */
import { defineMessages } from 'react-intl';

export const scope = 'app.components.AnswerImageUpload';

export default defineMessages({
  defaultError: {
    id: `${scope}.defaultError`,
    defaultMessage: 'Something went wrong',
  },
  fileTooLargeError: {
    id: `${scope}.fileTooLargeError`,
    defaultMessage: 'The selected file is too large',
  },
  fileTooLongError: {
    id: `${scope}.fileTooLongError`,
    defaultMessage: 'The selected file duration is too long.',
  },
  unsupportedMediaType: {
    id: `${scope}.unsupportedMediaType`,
    defaultMessage: 'Unsupported media type',
  },
  previewImage: {
    id: `${scope}.previewImage`,
    defaultMessage: 'Preview image',
  },
  recommendedSpecsImage: {
    id: `${scope}.recommendedSpecsImage`,
    defaultMessage: 'Recommended image specs:',
  },
  recommendedSpecsSVG: {
    id: `${scope}.recommendedSpecsSVG`,
    defaultMessage: 'Recommended svg specs:',
  },
  recommendedSpecsAudio: {
    id: `${scope}.recommendedSpecsAudio`,
    defaultMessage: 'Recommended audio specs:',
  },
  recommendedSpecsVideo: {
    id: `${scope}.recommendedSpecsVideo`,
    defaultMessage: 'Recommended video specs:',
  },
  recommendedImageSpecs: {
    id: `${scope}.recommendedImageSpecs`,
    defaultMessage:
      'Size: 1920px x 1080px, <2MB, Ratio: 16:9, Type: jpg, jpeg, png, gif, Color space: RGB, Maximum supported file size: 10MB',
  },
  recommendedSVGSpecs: {
    id: `${scope}.recommendedSVGSpecs`,
    defaultMessage:
      '<2MB, Type: svg, Color space: RGB, Maximum supported file size: 10MB',
  },
  recommendedVideoSpecs: {
    id: `${scope}.recommendedVideoSpecs`,
    defaultMessage:
      'Size: 1920px x 1080px, <25MB, Ratio: 16:9, Type: avi, mp4, mkv, mov, flv, wmv, Maximum supported file size: 100MB',
  },
  recommendedAudioSpecs: {
    id: `${scope}.recommendedAudioSpecs`,
    defaultMessage:
      'Size: <25MB. Duration: <120 seconds, Type: mp3, Maximum supported file size: 100MB',
  },
});
